import React, { memo } from "react";
import styles from "./customLabel.module.scss";

const CustomLabel = ({ className, value, children, secondaryLabel = false, required = false, error = false }) => (
    <div
        className={`
            ${className}
            ${!secondaryLabel ? styles.primarylabel : styles.secondaryLabel}
            ${required && styles.dot}
            ${error && `${styles.error} ${styles.errorDot}`}
        `}
    >
        {value || children}
    </div>
);

export default memo(CustomLabel);
